// 失物招领 - 列表
import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Button, Empty, Input, Pagination, Select, Spin } from "antd"
import { ArrowLeftOutlined, CaretLeftOutlined, SearchOutlined } from '@ant-design/icons'
import TitleComponent from "@/components/sc/TitleComponent"
import SliderComponent from "@/components/sc/SliderComponent"
import PageFooter from "@/components/sc/PageFooter"
import api from "@/net/api"

import ImgPhone from "@/assets/img/lost-and-found/phone.png"
import ImgQrCode from "@/assets/img/lost-and-found/qrcode.png"
import ImgBgTop from "@/assets/img/lost-and-found/bg-top.png"
import ImgBgBottom from "@/assets/img/lost-and-found/bg-bottom.png"
import ImgIconCollege from "@/assets/img/lost-and-found/icon-college.png"
import ImgEmpty from '@/assets/img/home/noData.png'

import Info, { NoImg } from "./info.js"

import "./index.less"

export default function Index(props) {
	// ----------------------------------------------------------------------
	const [inSearch, setInSearch] = useState(false)
	function onClickSearch() {
		setInSearch(true)
	}
	function onClickBack() {
		if (inSearch) {
			setInSearch(false)
			return
		}
		window.history.back()
	}

	// ----------------------------------------------------------------------
	const [infoModal, setInfoModal] = useState({
		visible: false,
		info: {},
	})
	function onClickItem(item) {
		setInfoModal({ visible: true, info: item })
	}
	function onCancelInfoModal() {
		setInfoModal({ visible: false, info: {} })
	}

	// ----------------------------------------------------------------------
	return (
	<>
		<div className="pages_main_lost-and-found" style={props.style || {}}>
			<div className="page-top">
				<div className="top-title">失物招领公告栏</div>
				<div className="top-right">
					{!inSearch &&
					<div className="right-button" onClick={() => onClickSearch()}>
						<SearchOutlined className="button-icon" />
						<span className="button-label">搜索</span>
					</div>
					}
					<div className="right-button" onClick={() => onClickBack()}>
						<ArrowLeftOutlined className="button-icon" />
						<span className="button-label">返回</span>
					</div>
				</div>
			</div>

			{inSearch
			? <ListSearch onClickItem={onClickItem} />
			: <ListEntry onClickItem={onClickItem} />
			}

			<div className="notice">
				<div className="notice-title">发布公告</div>
				<div className="notice-main">
					<img className="notice-phone" src={ImgPhone} />
					<div className="notice-qrcode">
						<img className="qrcode-img" src={ImgQrCode} />
						<div className="qrcode-right">
							<div className="qrcode-label">微信扫码填写</div>
							<CaretLeftOutlined className="qrcode-icon" />
						</div>
					</div>
					<div className="notice-other">
						<div className="other-item item-1">
							微信扫描二维码，进入“U饭校园”中失物招领，切换至当前学校（区），根据提示填写提交即可。
							<div className="other-item-title">方式一</div>
						</div>
						<div className="other-item">
							搜索下载“U饭云餐-高校版”移动客户端，切换至当前学校（区），在首页进入“失误招领”根据提示填写提交即可。
							<div className="other-item-title">方式二</div>
						</div>
					</div>
				</div>
			</div>

			<SliderComponent style={{ marginTop: "57px" }} />
			<PageFooter style={{ color: "#fff", marginTop: "26px", position: "relative" }} />
		</div>

		<Info visible={infoModal.visible} info={infoModal.info} onCancel={onCancelInfoModal} />
	</>
	)
}

function ListEntry(props) {
	const user = useSelector(state => state.sysuserInfo || {})

	const [table, setTable] = useState({ list: [], total: 0 })
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		async function getList() {
			let param = {
				currentPage: 1,
				pageSize: 100,
				orgRegionId: user.orgRegionId,
			}
			setLoading(true)
			try {
				let d = await api.ConvenientService_lostFind_list(param)

				// TODO
				d.list.forEach(item => {
					item.orgRegionName = "潍坊学院"
				})

				setTable({ list: d.list, total: d.total })
			} catch(e) {
				console.log(e)
			} finally {
				setLoading(false)
			}
		}

		getList()
	}, [])

	return (
	<>
		<div className="list-entry">
		{table.list.map((item, i) =>
			<ListItem key={i} item={item} onClickItem={() => props.onClickItem(item)} />
		)}
		</div>
		<img className="list-entry-bg-top" src={ImgBgTop} />
		<img className="list-entry-bg-bottom" src={ImgBgBottom} />
	</>
	)
}

function ListSearch(props) {
	const user = useSelector(state => state.sysuserInfo || {})

	const TYPE_OPTIONS = [
		{ label: "丢失", value: "LOST" },
		{ label: "寻找", value: "FIND" },
	]

	const [filter, setFilter] = useState({
		type: null,
		title: "",
	})
	function onFilterTypeChange(e) {
		setFilter({ ...filter, type: e })
	}
	function onFilterTitleChange(e) {
		setFilter({ ...filter, title: e.target.value })
	}
	function search() {
		if (page == 1) {
			getList()
		} else {
			setPage(1)
		}
	}

	const [table, setTable] = useState({ list: [], total: 0 })
	const [page, setPage] = useState(1)
	const PAGE_SIZE = 6
	const [loading, setLoading] = useState(false)

	async function getList() {
		let param = {
			currentPage: page,
			pageSize: PAGE_SIZE,
			orgRegionId: user.orgRegionId,
		}
		if (filter.type) {
			param.type = filter.type
		}
		if (filter.title) {
			let title = filter.title.trim()
			if (title) {
				param.title = title
			}
		}

		setLoading(true)
		try {
			let d = await api.ConvenientService_lostFind_list(param)
			setTable({ list: d.list, total: d.total })
		} catch(e) {
			console.log(e)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		getList()
	}, [page])

	// ----------------------------------------------------------------------
	function onPageChange(page) {
		setPage(page)
	}
	function pageItemRender(_, type, originalElement) {
		if (type == "prev") {
			return <Button className="page-button">上一页</Button>
		}
		if (type == "next") {
			return <Button className="page-button">下一页</Button>
		}
		return originalElement
	}

	return (
	<div className="list-search">
		<div className="search-filter">
			<div className="filter-left">
				<Select className="left-select" placeholder="请选择类型/丢失/招领"
					value={filter.type} onChange={onFilterTypeChange}
					options={TYPE_OPTIONS} allowClear />
				<Input className="left-input" placeholder="请输入标题名称" allowClear
					value={filter.title} onChange={onFilterTitleChange} />
			</div>
			<div className="filter-right" onClick={() => search()}>
				<SearchOutlined className="right-icon" />
			</div>
		</div>

		{loading
		? <Spin className="loading" />
		: <>
		{table.total != 0
			? <>
				<div className="search-list">
				{table.list.map((item, i) =>
					<ListItem key={i} item={item} onClickItem={() => props.onClickItem(item)} />
				)}
				</div>
				<Pagination className="pagination" itemRender={pageItemRender} onChange={onPageChange}
					showTotal={(total) => <div className="page-total">{`共${total}个结果`}</div>}
					total={table.total} current={page} pageSize={PAGE_SIZE} />
				</>
			: <Empty className="empty" image={ImgEmpty} description="暂无内容~" />
			}
		</>
		}
	</div>
	)
}

function ListItem({ item, onClickItem }) {
	return <div className="list-item" onClick={() => onClickItem()}>
		<div className="item-title ellipsis1">{ item.title }</div>
		<div className="item-line">
			{item.type == "LOST"
			? <div className="item-type item-type-lost">丢失</div>
			: <div className="item-type item-type-find">招领</div>
			}
			<div className="item-school">
				<img className="school-img" src={ImgIconCollege} />
				<div className="school-label">{ item.orgRegionName }</div>
			</div>
		</div>
		<div className="item-content ellipsis2">{ item.content }</div>
		{item.picUrlList?.length > 0
		? <div className="item-imgs">
			{item.picUrlList.map((img, i) =>
				<img className="item-img" src={img} key={i} />
			)}
			</div>
		: <NoImg className="item-no-img" />
		}
	</div>
}
